import * as React from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "../lib/cn";

export function Breadcrumb({ className, ...props }: React.ComponentPropsWithoutRef<"nav">) {
  return <nav aria-label="breadcrumb" className={className} {...props} />;
}

export function BreadcrumbList({ className, ...props }: React.ComponentPropsWithoutRef<"ol">) {
  return (
    <ol
      className={cn(
        "flex flex-wrap items-center gap-1.5 text-sm text-zinc-500 dark:text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

export function BreadcrumbItem({ className, ...props }: React.ComponentPropsWithoutRef<"li">) {
  return <li className={cn("flex items-center gap-1.5", className)} {...props} />;
}

export const BreadcrumbLink = React.forwardRef<HTMLButtonElement, React.ComponentPropsWithoutRef<"button">>(
  ({ className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        "font-medium text-zinc-600 transition-colors hover:text-brand-700 dark:text-muted-foreground dark:hover:text-primary",
        className,
      )}
      {...props}
    />
  ),
);
BreadcrumbLink.displayName = "BreadcrumbLink";

export function BreadcrumbPage({ className, ...props }: React.ComponentPropsWithoutRef<"span">) {
  return (
    <span
      className={cn("font-semibold text-zinc-900 dark:text-foreground", className)}
      aria-current="page"
      {...props}
    />
  );
}

export function BreadcrumbSeparator({ className, ...props }: React.ComponentPropsWithoutRef<"li">) {
  return (
    <li role="presentation" aria-hidden="true" className={cn("text-zinc-300 dark:text-muted-foreground/50", className)} {...props}>
      <ChevronRight className="h-3.5 w-3.5" />
    </li>
  );
}
